import {makeRequest, makeRequestGet, makeRequestPut} from '../../Services/API';

export function getOrdensServico(oficina, utilizador, lang) {
    let params = {
        user: utilizador,
        estabelecimento: oficina,
        status: '',
        localizacao: '',
    };
    return makeRequest(`/backend/ordem_servico/${lang}`, params);
}

export function getObservacao(numPedido) {
    let params = {
        numPedido: numPedido,
    };

    return makeRequest(`/backend/observacoes2/POR`, params);
}

export function getObservacoes() {
    return makeRequestGet(`/backend/observacoes/POR`);
}

export function guardarObservacao(numOrdem, observacao) {
    let params = {
        // numPedido: numOrdem,
        observacao: observacao,
    };

    // return makeRequestPut(
    //   `/backend/observacoesPUT/POR`,
    //   params
    // );
    return makeRequest(`/backend/ordem_servico/POR/${numOrdem}/observacao`, params);
}

export function iniciarTempos(numOrdem, cliente, utilizador, oficina) {
    let params = {
        user: utilizador,
        estabelecimento: oficina,
        numeroCliente: cliente,
    };
    return makeRequest(`/backend/ordem_servico/POR/${numOrdem}/inicia_tempo`, params);
}

export function pausaTempo(numOrdem, cliente, utilizador, oficina) {
    let params = {
        user: utilizador,
        estabelecimento: oficina,
        numeroCliente: cliente,
    };
    return makeRequest(`/backend/ordem_servico/POR/${numOrdem}/pausa_tempo`, params);
}

export function faltaPecas(numOrdem, utilizador) {
    let params = {
        user: utilizador,
    };

    return makeRequest(`/backend/ordem_servico/POR/${numOrdem}/falta_pecas`, params);
}

export function estadoOS(user) {
    return makeRequestGet(`/backend/ordem_servico/${'POR'}/os_curso/?user=${user}`);
}

// export function guardarDespesa(data) {
// }
//   return makeRequestGet(`/backend/despesas/${"POR"}/Criar`, data);
// }
